<template>
<div class="row plain-element">
    <div v-if="!isLoggedIn()"  class="dashboard-cards">
        <NoPermissionComponent/>
    </div>
   <div v-if="getUsername() && getDivisionPlanData()" class="dashboard">
    <div class="row row-cards">
      <div class="row text-start row-back">
        <a class="back-link" @click="hasHistory() ? $router.go(-1): $router.push('/')">
          <span class="material-icons chevron-left">chevron_left</span> Back To Plan
        </a>
      </div>
    </div>
    <div   v-if="getDivisionPlanData().plan_manager === getUsername()" class="card card-details">
      <p class="error"  v-if="getFormError()">
        <span id="formError">{{ getFormError() }}</span>
      </p>
      <p class="error"  v-else>
      </p>
      <UpdateDivisionPlanRefLineComponent
              :id = id
              :current_name = getDivisionPlanData().name
              :current_company = getDivisionPlanData().company
              :current_description = getDivisionPlanData().description
              :current_currency = getDivisionPlanData().currency

              :current_macc_carbon_offsetting_cost = getDivisionPlanData().macc_carbon_offsetting_cost
              :current_macc_carbon_per_money = getDivisionPlanData().macc_carbon_per_money
      />
    </div>
  </div>
</div>
</template>


<script>

import { mapGetters, mapActions } from "vuex";
import { hasHistory } from "@/common/general.js";
import UpdateDivisionPlanRefLineComponent from "@/components/division_plans/UpdateDivisionPlanRefLineComponent.vue";
import NoPermissionComponent from "@/components/NoPermissionComponent.vue"

export default {
  name: "DivisionPlanRefLineUpdate",
  components: {
    UpdateDivisionPlanRefLineComponent,
    NoPermissionComponent,
  },
  props: {
    id: { type: String, required: true },
  },
  data() {
    return {

    }
  },
  methods: {
    ...mapGetters(["getDivisionPlanData","getFormError", "getUsername", "isLoggedIn"]),
    ...mapActions(["fetchDivisionPlanData", "performSetFormError"]),
    hasHistory: hasHistory,
    getPlanDetails() {
      this.fetchDivisionPlanData({"id": this.id })
    },
  },

  created() {
    this.getPlanDetails();
    this.performSetFormError(null);
    document.title = "Update Ref. Lines";
    window.scrollTo(0,0);
  },
  beforeRouteUpdate (to, from, next) {
    this.getPlanDetails();
    next();
  }
}


</script>
